import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import carPricing from '../../../js/stores/car-pricing.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var carPricings = [];
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return carPricing.dispatch('getList');
        case 1:
          result = _context.sent;
          if (result.status !== undefined && result.status !== 200) {
            console.log(result.data.messages.error);
            result = [];
          }
          carPricings = result;
          $update();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var goCarPricingEdit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var anchor, carPricingId, CarPricingItem, obj;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            anchor = e.target.closest("a");
            carPricingId = anchor.dataset.carPricingId;
            CarPricingItem = carPricings.filter(function (item) {
              return item.CarPricingId == carPricingId;
            })[0];
            if (!(Number(CarPricingItem.CarMinPrice) == 0)) {
              _context2.next = 1;
              break;
            }
            $f7.toast.show({
              text: 'This option can not be edited',
              closeTimeout: 4000
            });
            return _context2.abrupt("return");
          case 1:
            obj = {
              props: CarPricingItem
            };
            $f7.views.main.router.navigate('/car-pricing-edit/', obj);
            $update();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function goCarPricingEdit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="car-pricing-dashboard">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Back</span>
          </a>
        </div>
        <div class="title">${locale.translate('admin.sections.carPricing')}</div>
      </div>
    </div>
    <div class="page-content">
      <div id="container" class="center-content">
        <div class="list media-list list-outline-ios list-strong-ios list-dividers-ios">
          <ul>
          ${carPricings.length > 0 && $h`
          ${carPricings.map((item) => $h`
            <li>
              <a class="item-link item-content popup-open" data-popup=".car-pricing-popup" @click="${goCarPricingEdit}" data-car-pricing-id="${item.CarPricingId}">
                <div class="item-inner" >
                  <div class="item-title-row">
                    <div class="item-title">${locale.translate('car.edit.carSize')}: ${locale.translate(`general.sizeList[${item.CarSizeIndex}]`)}</div>
                    <div class="item-after"><i class="icon material-symbols-outlined color-green">edit</i>${locale.translate('general.edit')}</div>
                  </div>
                  <div class="item-text">
                    ${locale.translate('car.edit.carEstimatedPrice')}: € ${item.CarMinPrice} | € ${item.CarMaxPrice}<br/>
                    ${locale.translate('car.edit.suggestedLoanPrice')}: € ${item.MinRecommendedPrice} | € ${item.MaxRecommendedPrice}
                  </div>
                </div>
              </a>
            </li>
          `)}
          `}
          </ul>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = 'a4d89cf085';
export default framework7Component;